import React from "react";
import { IRetailStoreWithDistance } from "tsi-common-react/src/models/location.interfaces";
import { ISyncStoreID } from "tsi-common-react/src/models/nominals";
import { ajax } from "tsi-common-react/src/utils/ajax";

import iconIconTxt from "../../img/retail-locator/icon-txt.svg";
import { ITXTSendStorePostData } from "../models.interfaces";
import { buildStoreData } from "../utils";
import { LocatorSendResultsModal } from "./LocatorSendResults_Modal";

interface IProps {
    stores: IRetailStoreWithDistance[];
    getStoreNumber: (store: IRetailStoreWithDistance) => number;
}

interface IState {}

// TODO(ssr, LOW 3 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 3/10 due to async AJAX submission handler and passthrough rendering to LocatorSendResultsModal with no state or lifecycle methods.
export class LocatorSendResultsText extends React.Component<IProps, IState> {
    state: IState = {};

    private readonly onSubmit = async (
        recipient: string,
        selectedStores: Set<ISyncStoreID>,
    ) => {
        const data: ITXTSendStorePostData = {
            brand: "TP",
            triggerExternalCall: true,
            program: "text",
            phone: recipient,
            stores: buildStoreData(this.props.stores, selectedStores),
        };
        await ajax
            .post("https://api.promosis.com/api/v1/tsi-2249/text")
            .send(data);
    };

    render() {
        return (
            <LocatorSendResultsModal
                modalClassName="modal-txt"
                // TODO(i18n): Use t tagged template: buttonLabel={t`Text Results`}
                buttonLabel="Text Results"
                buttonImgSrc={iconIconTxt}
                // TODO(i18n): Use t tagged template: buttonImgAlt={t`Text Results`}
                buttonImgAlt="Text Results"
                // TODO(i18n): Use t tagged template: modalTitle={t`Text Your Results`}
                modalTitle="Text Your Results"
                // TODO(i18n): Use jt to keep sentence together with interpolated components: modalDescription={jt`Check up to ${<strong>3</strong>} ${<span>results</span>} you would like texted.${<br />}Message and data rates may apply.`}
                modalDescription={
                    <>
                        Check up to <strong>3</strong> <span>results</span> you
                        would like texted.
                        <br />
                        Message and data rates may apply.
                    </>
                }
                inputType="phone"
                // TODO(i18n): Use t tagged template: inputPlaceholder={t`Enter a Phone Number`}
                inputPlaceholder="Enter a Phone Number"
                // TODO(i18n): Use t tagged template: submitButtonLabel={t`Send`}
                submitButtonLabel="Send"
                maxSelected={3}
                stores={this.props.stores}
                getStoreNumber={this.props.getStoreNumber}
                onSubmit={this.onSubmit}
            />
        );
    }
}
